import {
  buildSchema,
  GraphQLEnumType,
  GraphQLField,
  GraphQLList,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLScalarType,
  GraphQLUnionType,
} from "graphql";

export function listMutations(schemaSDL: string): string[] {
  const schema = buildSchema(schemaSDL);
  const mutationType = schema.getMutationType();
  if (!mutationType) return [];
  return Object.keys(mutationType.getFields()).sort((a, b) =>
    a.localeCompare(b),
  );
}

export function listQueries(schemaSDL: string): string[] {
  const schema = buildSchema(schemaSDL);
  const queryType = schema.getQueryType();
  if (!queryType) return [];
  return Object.keys(queryType.getFields()).sort((a, b) => a.localeCompare(b));
}

export function getOperationDefinition(
  schemaSDL: string,
  operationType: "mutation" | "query",
  name: string,
): GraphQLField<any, any> {
  const schema = buildSchema(schemaSDL);
  const type =
    operationType === "mutation"
      ? schema.getMutationType()
      : schema.getQueryType();
  if (!type) throw new Error(`Schema has no ${operationType} type`);
  const field = type.getFields()[name];
  if (!field) throw new Error(`${operationType} ${name} not found`);
  return field;
}

/** Fields selected by default for the operation's result: every scalar/enum
 *  field one level below the return type. Union return types yield
 *  `[TypeName].field` paths for every member type, so error members such as
 *  GenericException are visible without manual selection. */
export function defaultSelectionPaths(
  schemaSDL: string,
  name: string,
  operationType: "mutation" | "query",
): Set<string> {
  const field = getOperationDefinition(schemaSDL, operationType, name);
  let rtype: any = field.type;
  while (rtype instanceof GraphQLNonNull || rtype instanceof GraphQLList)
    rtype = rtype.ofType;

  const set = new Set<string>();
  if (rtype instanceof GraphQLUnionType) {
    for (const member of rtype.getTypes()) {
      for (const key of scalarFieldNames(member)) {
        set.add(`[${member.name}].${key}`);
      }
    }
  } else if (rtype instanceof GraphQLObjectType) {
    for (const key of scalarFieldNames(rtype)) set.add(key);
  }
  return set;
}

function scalarFieldNames(type: GraphQLObjectType): string[] {
  const fields = type.getFields();
  return Object.keys(fields).filter((key) => {
    let t: any = fields[key].type;
    while (t instanceof GraphQLNonNull || t instanceof GraphQLList)
      t = t.ofType;
    return t instanceof GraphQLScalarType || t instanceof GraphQLEnumType;
  });
}
